import React from 'react';
import PropTypes from 'prop-types';
import {Row, UncontrolledTooltip} from 'reactstrap';


const TableOptions = ({onDelete, onEdit, currentRow, onDuplicate, onImpersonate, onView}) => {
    return (
        <div>
            <Row>
                <div className='mr-2'>
                        <span className='text-warning pointer'>
                            <i
                                id={`tooltip-target-one${currentRow}`}
                                className='material-icons ml-2'
                                onClick={e => {
                                    e.stopPropagation();
                                    onEdit();
                                }}
                            >
                                edit
                            </i>
                        </span>
                </div>
                <UncontrolledTooltip
                    className='table-tooltip'
                    placement='left'
                    delay={{hide: 0}}
                    target={`tooltip-target-one${currentRow}`
                    }>
                    Edit
                </UncontrolledTooltip>

                {onDelete &&
                    <div>
                        <div className='mr-2'>
                            <span className='text-danger pointer'>
                                <i
                                    id={`tooltip-target-two${currentRow}`}
                                    className='material-icons'
                                    onClick={e => {
                                        e.stopPropagation();
                                        onDelete();
                                    }}>delete
                                </i>
                            </span>
                        </div>
                        <UncontrolledTooltip
                            className='table-tooltip'
                            placement='right'
                            delay={{hide: 0}}
                            target={`tooltip-target-two${currentRow}`}>
                            Delete
                        </UncontrolledTooltip>
                    </div>
                }

                {onDuplicate ?
                    <div>
                        <div>
                                <span
                                    className='text-success pointer'
                                >
                                    <i
                                        id={`tooltip-target-three${currentRow}`}
                                        className='material-icons'
                                        onClick={e => {
                                            e.stopPropagation();
                                            onDuplicate();
                                        }}
                                    >filter_none
                                    </i>
                                </span>
                        </div>
                        <UncontrolledTooltip
                            className='table-tooltip'
                            placement='right'
                            delay={{hide: 0}}
                            target={`tooltip-target-three${currentRow}`}>
                            Duplicate
                        </UncontrolledTooltip>
                    </div> : null
                }
                {onImpersonate ?
                    <div>
                        <div>
                                <span
                                    className='text-success pointer'
                                >
                                    <i
                                        id={`tooltip-target-three${currentRow}`}
                                        className='material-icons'
                                        onClick={e => {
                                            e.stopPropagation();
                                            onImpersonate();
                                        }}
                                    >transfer_within_a_station
                                    </i>
                                </span>
                        </div>
                        <UncontrolledTooltip
                            className='table-tooltip'
                            placement='right'
                            delay={{hide: 0}}
                            target={`tooltip-target-three${currentRow}`}>
                            Impersonate
                        </UncontrolledTooltip>
                    </div> : null
                }
                {onView ?
                    <div>
                        <div>
                                <span
                                    className='text-success pointer'
                                >
                                    <i
                                        id={`tooltip-target-three${currentRow}`}
                                        className='material-icons'
                                        onClick={e => {
                                            e.stopPropagation();
                                            onView();
                                        }}
                                    >zoom_in
                                    </i>
                                </span>
                        </div>
                        <UncontrolledTooltip
                            className='table-tooltip'
                            placement='right'
                            delay={{hide: 0}}
                            target={`tooltip-target-three${currentRow}`}>
                            View
                        </UncontrolledTooltip>
                    </div> : null
                }
            </Row>
        </div>
    );
};


TableOptions.propTypes = {
    onImpersonate: PropTypes.func,
    onEdit: PropTypes.func,
    onDelete: PropTypes.func,
    currentRow: PropTypes.number,
    onDuplicate: PropTypes.func,
    onView: PropTypes.func,
};

TableOptions.defaultProps = {
    onDelete: null,
    onImpersonate: null,
    onView: null,
};

export default TableOptions;


// WEBPACK FOOTER //
// ./src/common/TableOptions.js